import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { AudioProvider } from "@/context/AudioContext";
import AgeGate from "@/components/AgeGate";
import Navbar from "@/components/Navbar";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Explore from "@/pages/Explore";
import Feed from "@/pages/Feed";
import CreatorProfile from "@/pages/CreatorProfile";
import PostDetail from "@/pages/PostDetail";
import Messages from "@/pages/Messages";
import Studio from "@/pages/Studio";
import Settings from "@/pages/Settings";
import PaymentResult from "@/pages/PaymentResult";
import Admin from "@/pages/Admin";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return <div className="min-h-screen flex items-center justify-center text-muted-foreground">Loading…</div>;
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function Shell() {
  return (
    <>
      <AgeGate />
      <Navbar />
      <main className="pt-16 min-h-screen">
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/explore" element={<Explore />} />
          <Route path="/u/:username" element={<CreatorProfile />} />
          <Route path="/post/:id" element={<PostDetail />} />
          <Route path="/feed" element={<Protected><Feed /></Protected>} />
          <Route path="/messages" element={<Protected><Messages /></Protected>} />
          <Route path="/messages/:userId" element={<Protected><Messages /></Protected>} />
          <Route path="/studio" element={<Protected><Studio /></Protected>} />
          <Route path="/settings" element={<Protected><Settings /></Protected>} />
          <Route path="/admin" element={<Protected><Admin /></Protected>} />
          <Route path="/payment/success" element={<PaymentResult />} />
          <Route path="/payment/cancel" element={<PaymentResult />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
    </>
  );
}

export default function App() {
  return (
    <div className="App noise-overlay">
      <ReactLenis root options={{ lerp: 0.08, smoothWheel: true }}>
        <AuthProvider>
          <AudioProvider>
            <BrowserRouter>
              <Shell />
            </BrowserRouter>
            <Toaster theme="dark" position="top-center" toastOptions={{ style: { background: "#121212", border: "1px solid #262626", color: "#f5f5f5" } }} />
          </AudioProvider>
        </AuthProvider>
      </ReactLenis>
    </div>
  );
}
